module.exports = __webpack_public_path__ + "goal.bacab2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/goal.png
// module id = 914
// module chunks = 0